import React from 'react';
import PropTypes from 'prop-types';

export const ManualVerification = ({ width, height, ...props }) => (
  <svg
    data-icon='manual-verification'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M7.827 23c-.4 0-.784-.075-1.15-.225a2.942 2.942 0 0 1-.975-.65L.602 17l.825-.85c.233-.233.516-.392.85-.475a2.032 2.032 0 0 1 1 0l1.725.5V8c0-.283.095-.52.287-.713A.968.968 0 0 1 6.002 7c.283 0 .52.096.712.287.192.192.288.43.288.713v10.825l-2.45-.7L7.127 20.7c.1.1.208.175.325.225.116.05.241.075.375.075h4.175c.55 0 1.02-.196 1.412-.587.392-.392.588-.863.588-1.413v-4c0-.283.095-.52.287-.713a.967.967 0 0 1 .713-.287c.283 0 .52.096.712.287.192.192.288.43.288.713v4c0 1.1-.392 2.042-1.175 2.825-.784.783-1.725 1.175-2.825 1.175H7.827Zm.175-7v-4c0-.283.095-.52.287-.713A.967.967 0 0 1 9.002 11c.283 0 .52.096.712.287.192.192.288.43.288.713v4h-2Zm3 0v-3c0-.283.095-.52.287-.713a.967.967 0 0 1 .713-.287c.283 0 .52.096.712.287.192.192.288.43.288.713v3h-2Zm5-5c-1.517 0-2.917-.4-4.2-1.2a6.945 6.945 0 0 1-2.8-3.3 6.945 6.945 0 0 1 2.8-3.3 7.788 7.788 0 0 1 4.2-1.2c1.516 0 2.916.4 4.2 1.2 1.283.8 2.216 1.9 2.8 3.3a6.945 6.945 0 0 1-2.8 3.3 7.789 7.789 0 0 1-4.2 1.2Zm0-2a5.79 5.79 0 0 0 2.687-.65 5.434 5.434 0 0 0 2.063-1.85 5.434 5.434 0 0 0-2.063-1.85A5.79 5.79 0 0 0 16.002 4a5.79 5.79 0 0 0-2.688.65 5.433 5.433 0 0 0-2.062 1.85c.533.8 1.22 1.417 2.062 1.85a5.79 5.79 0 0 0 2.688.65Zm0-1c-.417 0-.771-.146-1.063-.438a1.446 1.446 0 0 1-.437-1.062c0-.417.145-.77.437-1.063A1.446 1.446 0 0 1 16.002 5c.416 0 .77.146 1.062.438.292.291.438.645.438 1.062 0 .417-.146.77-.438 1.063A1.447 1.447 0 0 1 16.002 8Z'
    />
  </svg>
);

ManualVerification.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ManualVerification.defaultProps = {
  width: 24,
  height: 24,
};
